import { Helmet } from "react-helmet";

import SEO from "../../data/seo";
import { SITE } from "../../data/site";

const Meta = ({ page }) => {
	const entry = SEO.find((item) => item.page === page) || SEO[0];

	return (
		<Helmet>
			<title>{entry.title}</title>
			<meta name="description" content={entry.description} />
			<meta name="keywords" content={entry.keywords.join(", ")} />
			<meta property="og:title" content={entry.title} />
			<meta property="og:description" content={entry.description} />
			<meta property="og:type" content="website" />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={entry.title} />
			<meta name="twitter:description" content={entry.description} />
			<meta name="author" content={SITE.name} />
		</Helmet>
	);
};

export default Meta;
